enum ProjectStage {
  Assessment = 1,
  Sourcing = 2,
  Ongoing = 3,
  Completed = 4,
  Cancelled = 5,
  Archived = 6
}

export default ProjectStage;
